import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const IndexScaleSmall = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 15.1458C11.866 15.1458 15 11.9792 15 8.07292C15 4.16665 11.866 1 8 1C4.13401 1 1 4.16665 1 8.07292C1 11.9792 4.13401 15.1458 8 15.1458Z"
                    stroke="#60BF63"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.66668 5.95093C5.79555 5.95093 5.90002 6.05648 5.90002 6.18669C5.90002 6.3169 5.79555 6.42246 5.66668 6.42246C5.53782 6.42246 5.43335 6.3169 5.43335 6.18669C5.43335 6.05648 5.53782 5.95093 5.66668 5.95093"
                    stroke="#60BF63"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.3333 5.95093C10.4622 5.95093 10.5666 6.05648 10.5666 6.18669C10.5666 6.3169 10.4622 6.42246 10.3333 6.42246C10.2044 6.42246 10.1 6.3169 10.1 6.18669C10.1 6.05648 10.2044 5.95093 10.3333 5.95093"
                    stroke="#60BF63"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.7633 9.95911C11.0543 11.4048 9.59558 12.3194 7.99882 12.3194C6.40206 12.3194 4.94332 11.4048 4.23438 9.95911"
                    stroke="#60BF63"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    ),
    'Index'
);
export default IndexScaleSmall;
